module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Thin-bd09b26462cdf4a533c4512c048e999d.woff2";